import { fmtDay } from './trackingUtils'

/** "Arriving by Fri, 10 Oct", "Delivered on …", or a Delayed badge with the original date. */
export default function DeliveryEta({ shipment, stage }) {
  const delivered = shipment.milestones?.delivered_at ?? shipment.delivered_at
  if (stage === 'delivered' && delivered) {
    return <Line icon="fa-circle-check" tone="text-green-600" title="Delivered on" value={fmtDay(delivered)} />
  }
  if (['rto', 'rto_delivered', 'cancelled', 'lost'].includes(stage)) return null
  const etd = shipment.etd ?? shipment.initial_etd
  if (!etd) return null
  if (shipment.is_delayed) {
    return (
      <div className="flex flex-wrap items-center gap-2">
        <Line icon="fa-clock" tone="text-amber-600" title="Running late" value="We'll update you as soon as the courier does" />
        <span className="inline-flex px-2.5 py-0.5 rounded-full bg-amber-50 border border-amber-200 text-amber-700 text-[10px] font-bold tracking-wider">
          DELAYED · WAS DUE {fmtDay(shipment.initial_etd ?? etd)?.toUpperCase()}
        </span>
      </div>
    )
  }
  return <Line icon="fa-calendar-check" tone="text-secondary" title="Arriving by" value={fmtDay(etd)} />
}

function Line({ icon, tone, title, value }) {
  return (
    <p className="flex items-center gap-3 normal-case">
      <i className={`fa-solid ${icon} ${tone}`} aria-hidden="true"></i>
      <span className="text-sm text-primary/60 tracking-wider">{title}</span>
      <span className={`text-base font-semibold ${tone}`}>{value}</span>
    </p>
  )
}
